import React, { useEffect, useRef, useState } from "react";
import {
  getDeleteUser,
  getManageUserList,
  getPasswordReset,
  reassignRole,
  role,
} from "./manageuserVerification/utils";
import {
  notificationStrings,
  openNotificationWithIcon,
} from "../../common/notification-message/notification";

import ManageuserPresentational from "./manageuserheader";
import { getManageuserdata } from "./manageuserVerification/mockdata";
import moment from "moment";
import { options } from "../settings/registrationaldetails/content";
import { useHistory } from "react-router-dom";
import { invalid } from "moment";

let rowsdata = [];
const ManageUsers = (props) => {
  const history = useHistory();
  const request = {
    page: 1,
    size: "",
    date: "",
    userName: "",
    email: "",
    role: "",
    lastLoginDateTime: "",
    action: "",

    searchFilter: "",
  };
  const [filterForm, setFilterForm] = useState(request);
  const [message, setMessage] = useState(false);
  const [deleteUserShow, setDeleteUserShow] = useState(false);
  const [reassignshow, setReassignshow] = useState(false);
  const [modalShow, setModalShow] = useState(false);
  const [searchBy, setSearchBy] = useState("userName");
  const [searchByValue, setSearchByValue] = useState("");
  const [filterValues, setFilterValues] = useState(false);
  const [adminStatus, setAdminStatus] = useState(false);
  const [superadminStatus, setSuperadminStatus] = useState(false);
  const [callcentreagentStatus, setCallcentreagentStatus] = useState(false);
  const [customerserviceStatus, setCustomerserviceStatus] = useState(false);
  const [dataLoading, setDataLoading] = useState(false);
  const [noOfFiltersSelected, setNoOfFiltersSelected] = useState(false);
  const [filtersSelected, setFiltersSelected] = useState(false);
  const [selectedOption, setSelectedOption] = useState("");
  const [manageUserList, setmanageUserList] = useState([]);
  const [DeleteList, setDeleteList] = useState([]);
  const [roleData, setRoleData] = useState([]);
  const [deleteLoader, setDeleteLoader] = useState(false);
  const [selectedRow, setSelectedRow] = useState("");
  const [loader, setLoader] = useState(false);
  const [row, setRow] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [excelList, setExcelList] = useState([]);
  const [userName, setuserName] = useState("");
  const [manageUserListExcel, setmanageUserListExcel] = useState([]);
  const [changePasswordPopup, setChangePasswordPopup] = useState(false);
  const [passwordRestUser, setPasswordRestUser] = useState("");
  const [passwordResetLoader, setPasswordResetLoader] = useState(false);
  const [pagination, setPagination] = useState({
    pageSize: 10,
    total: 0,
    current: 1,
  });
  const [sizeShow, setSizeShow] = useState();
  const [rowHandler, setRowhandler] = useState(false);
  const buttonRef = useRef("");
  const [roleinfo, setRoleinfo] = useState("");
  const rowEvents = {
    onClick: (e, row, rowIndex, data) => {
      console.log("row data", row, e, data);

      let states = { ...row };
      history.push({
        pathname: "/admin/user-profile",

        state: { id: states.userName, rowDate: states },
      });
      console.log("pathname", states.userName);
    },
    onMouseEnter: (e, row, rowIndex) => {
      console.log(`enter on row with index: ${rowIndex}`);
    },
  };

  const columns = [
    {
      dataField: "action",
      text: "Action",
      sort: false,
      headerStyle: { textAlign: "center" },
      style: { minWidth: "50px", textAlign: "center" },
      formatter: (cell, row) => {
        return (
          <div>
            <i
              style={{ fontSize: 18 }}
              className={"fas fa-trash-alt"}
              style={{ width: "25px", height: "15px", cursor: "pointer" }}
              onClick={() => {
                if (row && row.userName) {
                  setRow(row.userName);
                }
                setDeleteUserShow(true);
              }}
            />
            <i
              style={{ fontSize: 18 }}
              className={"fas fa-regular fa-key"}
              style={{ width: "25px", height: "15px", cursor: "pointer" }}
              onClick={() => {
                if (row && row.id) {
                  setPasswordRestUser(row.id);
                }
                setChangePasswordPopup(true);
              }}
            />
          </div>
        );
      },
    },
    {
      dataField: "createdDate",
      text: "Date",
      sort: false,
      style: { minWidth: "100px", textAlign: "center" },
      headerStyle: { textAlign: "center" },

      formatter: (cell, row) => {
        return moment((row && row.createdDate) || null).format(
          "DD-MM-YY  HH:mm:ss"
        );
      },
    },
    {
      dataField: "userName",
      text: "User Name",
      sort: false,
      headerStyle: { textAlign: "left" },
      style: { minWidth: "150px", textAlign: "left" },
    },
    {
      dataField: "email",
      text: "Email ",
      sort: false,
      headerStyle: { textAlign: "left" },
      style: { minWidth: "100px", textAlign: "left" },
    },
    {
      dataField: "role.name",
      text: "Role",
      sort: false,

      style: { minWidth: "150px", textAlign: "Left" },
    },
    {
      dataField: "",
      text: "",
      sort: false,
      style: { minWidth: "50px", textAlign: "center" },
      formatter: (cell, row) => {
        let states = { ...row };
        return (
          <div style={{ color: "black" }}>
            {" "}
            <i
              style={{ fontSize: 18 }}
              className="fas fa-edit"
              onClick={() => {
                if (row && row.userName) {
                  setRow(row);
                }
                setModalShow(true);
              }}
            />
          </div>
        );
      },
    },
    // {
    //   dataField: "lastLoginDateTime",
    //   text: "Last logged in Date Time",
    //   sort: false,
    //   headerStyle: { textAlign: "center" },
    //   style: { minWidth: "100px", textAlign: "center" },
    // },
  ];
  const columnsCsv = [
    { key: "createdDate", label: "Date" },
    { key: "userName", label: "User name" },
    { key: "email", label: "Email" },
    { key: "lastLoginDateTime", label: "Last logged in Date Time" },
    {
      key: "role",
      label: "role",
    },
  ];
  const columnsExcel = [
    { dataField: "createdDate", text: "Date" },
    { dataField: "userName", text: "User name" },
    { dataField: "email", text: "Email" },
    { dataField: "lastLoginDateTime", text: "Last logged in Date Time" },
    {
      dataField: "role",
      text: "role",
    },
  ];

  const rowClicked = (data) => {
    let states = { ...data };
    history.push({
      pathname: "/admin/user-profile",
      state: { id: states.id, rowData: states },
    });
  };

  useEffect(() => {
    if (filterForm) {
      getmanageUsers(filterForm);
    }
    const roleValue = async () => {
      let roleRes = await role();
      setRoleData(roleRes);
    };
    roleValue();
  }, [filterForm]);

  // roleAssign api
  const roleReassign = (roleinfo) => {
    const requestObj = {
      roleId: roleinfo,
    };
    setLoader(true);
    reassignRole(row.userName, requestObj)
      .then((res) => {
        setLoader(false);
        setModalShow(false);
        openNotificationWithIcon(
          notificationStrings.success,
          "Role Changed successfully."
        );
        getmanageUsers(filterForm);
      })
      .catch((err) => {
        setLoader(false);
      });
  };
  const statusFilter = () => {
    setNoOfFiltersSelected(selectedOption.length);
    setDeleteUserShow(false);
    setFiltersSelected(true);
    let filter = selectedOption.map((option) => {
      switch (option.label) {
        case "Admin":
          setAdminStatus(true);
          setFilterValues(filter);
          break;
        case "Callcentreagent":
          setCallcentreagentStatus(true);
          setFilterValues(!filterValues);
          break;
        case "Customerserviceagent":
          setCustomerserviceStatus(true);
          setFilterValues(!filterValues);
          break;
        case "Superadmin":
          setSuperadminStatus(true);
          setFilterValues(!filterValues);
          break;
        default:
          return "";
      }
    });
  };
  // Delete api
  const onDelete = () => {
    setDeleteLoader(true);
    getDeleteUser(row)
      .then((res) => {
        setDeleteUserShow(false);
        setDeleteLoader(false);
        //message.success("Delete Successfully");
        openNotificationWithIcon(
          notificationStrings.success,
          "Deleted Successfully"
        );

        let request = {};
        request.page = 1;
        request.size = "";
        setFilterForm(request);

        // getReferrerCodeList(filterForm, username);
      })
      .catch((err) => {
        setDeleteUserShow(false);
        openNotificationWithIcon(notificationStrings.error, err);
        setDeleteLoader(false);
      });
  };

  const getmanageUsers = (request) => {
    request.size = sizeShow || 10;
    setDataLoading(true);
    getManageUserList(request)
      .then((res) => {
        setDataLoading(false);
        if (res && res.data && res.data.users.length > 0) {
          setmanageUserList(() => res.data.users);
        } else {
          // setMessage(true);
          setmanageUserList([]);
        }
        setPagination({
          ...pagination,
          pageSize: sizeShow || 10,
          total: res.data.totalCount,
          current: request.page,
        });
      })
      .catch((err) => {
        setPagination({ ...pagination, pageSize: 10, total: 0, current: 1 });
        setDataLoading(false);
        setmanageUserList([]); //mockdata:getManageuserdata
      });
  };

  const resetFilter = () => {
    setSearchBy("userName");
    // setSearchByValue('');
    setFiltersSelected(false);
    setmanageUserList([]);
    setmanageUserListExcel([]);
    setFromDate("");
    setSelectedOption("");
    setFilterValues(false);
    setSearchByValue("");
    setFilterForm(request);
  };

  const handleFIlter = () => {
    let request = {};
    if (searchBy === "userName") {
      request = {
        ...filterForm,
        userName: searchByValue,
      };
    }
    if (searchBy === "email") {
      request = {
        ...filterForm,
        email: searchByValue,
      };
    }

    request.date =
      (fromDate &&
        moment(fromDate, "DD-MM-YY").format("YYYY-MM-DDTHH:mm:ss")) ||
      null;

    request.page = 1;
    request.size = "";
    setFilterForm(request);
  };

  const handleChangeFilter = (value, event) => {
    let request = {};
    if (event.key === "Enter") {
      if (searchBy === "userName") {
        request = {
          ...filterForm,
          userName: searchByValue,
        };
      }
      if (searchBy === "email") {
        request = {
          ...filterForm,
          email: searchByValue,
        };
      }

      request.date =
        (fromDate &&
          moment(fromDate, "DD-MM-YY").format("YYYY-MM-DDTHH:mm:ss")) ||
        null;

      request.page = 1;
      request.size = "";
      setFilterForm(request);
    }
  };

  const handleChange = (selectedOption) => {
    if (selectedOption) {
      setSelectedOption([...selectedOption]);
    } else {
      setSelectedOption("");
    }
  };
  // const handleChange = (selectedOption) => {
  //
  //   if (selectedOption) {
  //     var filter;
  //     filter =  manageUserList.filter((list)=>list.role && list.role.name === selectedOption.value)
  //     console.log("filter",filter)
  //     setmanageUserList(filter);
  //   }
  // };
  let searchByValuePlaceholder = "";
  if (searchBy === "userName") {
    searchByValuePlaceholder = "Amit Kanth";
  } else if (searchBy === "email") {
    searchByValuePlaceholder = "123@gmail.com";
  }

  const onExcelClciked = (filterForm) => {
    let request = filterForm;
    request.page = 1;
    request.size = "";
    getManageUserList(request)
      .then((res) => {
        if (res && res.data && res.data.users.length > 0) {
          let data = res.data.users.map((element) => {
            if (element.createdDate) {
              element.createdDate = moment(element.createdDate).format(
                "DD-MM-YYYY"
              );
            }
            if (element.role) {
              element.role = element.role.name;
            }

            return element;
          });
          setmanageUserListExcel(() => data);
          buttonRef.current.click();
        } else {
          setmanageUserListExcel([]);
        }
      })
      .catch((err) => {
        setmanageUserListExcel([]);
      });
  };

  const onPasswordChange = () => {
    setPasswordResetLoader(true);
    getPasswordReset(passwordRestUser)
      .then((res) => {
        setChangePasswordPopup(false);
        setPasswordResetLoader(false);
        openNotificationWithIcon(
          notificationStrings.success,
          "Password Reset Successfully"
        );

        let request = {};
        request.page = 1;
        request.size = "";
        setFilterForm(request);
      })
      .catch((err) => {
        setChangePasswordPopup(false);
        openNotificationWithIcon(notificationStrings.error, err);
        setPasswordResetLoader(false);
      });
  };
  return (
    <ManageuserPresentational
      searchBy={searchBy}
      // message={message}
      setSearchByValue={setSearchByValue}
      setSearchBy={setSearchBy}
      searchByValuePlaceholder={searchByValuePlaceholder}
      searchByValue={searchByValue}
      deleteLoader={deleteLoader}
      onDelete={onDelete}
      setDeleteLoader={setDeleteLoader}
      setDeleteUserShow={setDeleteUserShow}
      setReassignshow={setReassignshow}
      filtersSelected={filtersSelected}
      noOfFiltersSelected={noOfFiltersSelected}
      resetFilter={resetFilter}
      role={roleData}
      excelList={excelList}
      columnsExcel={columnsExcel}
      handleFIlter={handleFIlter}
      modalShow={modalShow}
      setModalShow={setModalShow}
      filterValues={filterValues}
      manageUserList={manageUserList}
      dataLoading={dataLoading}
      buttonRef={buttonRef}
      filterForm={filterForm}
      onExcelClciked={onExcelClciked}
      manageUserListExcel={manageUserListExcel}
      columns={columns}
      columnsCsv={columnsCsv}
      pagination={pagination}
      setPagination={setPagination}
      roleinfo={roleinfo}
      loader={loader}
      row={row}
      fromDate={fromDate}
      setFromDate={setFromDate}
      setFilterForm={setFilterForm}
      sizeShow={sizeShow}
      setSizeShow={setSizeShow}
      deleteuserShow={deleteUserShow}
      reassignshow={reassignshow}
      handleChange={handleChange}
      options={options}
      selectedRow={selectedRow}
      setRow={setRow}
      rowEvents={rowEvents}
      rowClicked={rowClicked}
      selectedOption={selectedOption}
      statusFilter={statusFilter}
      rowHandler={rowHandler}
      roleReassign={roleReassign}
      setmanageUserList={setmanageUserList}
      setChangePasswordPopup={setChangePasswordPopup}
      changePasswordPopup={changePasswordPopup}
      handleChangeFilter={handleChangeFilter}
      onPasswordChange={onPasswordChange}
      passwordResetLoader={passwordResetLoader}
    />
  );
};

export default ManageUsers;
